import Match3Game from './Match3Game.js';
import manifest from './manifest.js';
import type { GameRuntimeFactory } from '@adgf/game-engine';

export { default as Match3Game } from './Match3Game.js';
export { default as manifest } from './manifest.js';

/**
 * Runtime factory — creates a new Match3Game instance.
 */
export const createRuntime: GameRuntimeFactory = (config, events) => {
  return new Match3Game(config, events);
};

export default manifest;
